import data_grid, { OptionChangedEvent as GridOptionChangedEvent } from 'devextreme/ui/data_grid';
import popup from 'devextreme/ui/popup';
import select_box from 'devextreme/ui/select_box';
import tag_box from 'devextreme/ui/tag_box';

const DATE_COLUMN_TYPES = ['date', 'datetime'];
const SORT_ORDER_OPTION = /^columns\[(\d+)\]\.sortOrder$/;

export function sortDateColumnsDescFirst(e: GridOptionChangedEvent): void {
    if (e.value !== 'asc' || e.previousValue === 'desc') {
        return;
    }
    const match = SORT_ORDER_OPTION.exec(e.fullName ?? '');
    if (!match) {
        return;
    }
    if (typeof e.component?.columnOption !== 'function') {
        return;
    }
    const index = Number(match[1]);
    const dataType = e.component.columnOption(index, 'dataType') as string | undefined;
    if (!dataType || !DATE_COLUMN_TYPES.includes(dataType)) {
        return;
    }
    e.component.columnOption(index, 'sortOrder', 'desc');
}

const dropDownDefaults = {
    searchEnabled: true,
    searchMode: 'startswith' as const,
    searchTimeout: 0,
    showDataBeforeSearch: true,
};

select_box.defaultOptions({ options: dropDownDefaults });

tag_box.defaultOptions({ options: dropDownDefaults });

popup.defaultOptions({
    options: {
        dragEnabled: true,
        showCloseButton: true,
    },
});

data_grid.defaultOptions({
    options: {
        showBorders: true,
        allowColumnResizing: true,
        wordWrapEnabled: true,
        onOptionChanged: sortDateColumnsDescFirst,
    },
});
